import React, { useState, useEffect } from "react";

import Api from "../../../services/Api";

import { Link } from "react-router-dom";
import Config from "../../../config/Config";

import { FaSearch } from "react-icons/fa";

import { ToastContainer, toast } from "react-toastify";
import ReactLoading from "react-loading";
import Topmenu from "../../../components/adminqu/Topmenu";
import SideNav from "../../../components/adminqu/Sidenav";

function AdminquLinkReseller() {
  const [authUser, setAuthUser] = useState({});
  const [isDeleting, setIsDeleting] = useState(false);
  const [deletedLink, setDeletedLink] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");

  const [linkOriginal, setLinkOriginal] = useState([]);
  const [links, setLinks] = useState([]);
  const [status, setStatus] = useState("active");

  const [approvalLink, setApprovalLink] = useState({});
  const [isOpenModalApprove, setIsOpenModalApprove] = useState(false);

  const [editLink, setEditLink] = useState({});
  const [isOpenModalEdit, setIsOpenModalEdit] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const getInitialLinks = async (token, store_id) => {
    Api.get(
      "/items/Link?filter[store_id][_eq]=" +
        store_id +
        "&filter[status][_eq]=" +
        status +
        "&fields=*&limit=-1",
      token
    )
      .then((response) => {
        //console.log(response);
        if (response) {
          setLinkOriginal(response.data);
          setLinks(response.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        //console.log(error);
      });
  };

  useEffect(() => {
    const getUser = async (token) => {
      setIsLoading(true);
      Api.get("/users/me?fields=*,store_id.*", token)
        .then((response) => {
          //console.log(response);
          localStorage.setItem("auth_user", JSON.stringify(response.data));
          setAuthUser(response.data);
          getInitialLinks(token, response.data.store_id.id);
        })
        .catch((error) => {
          //console.log(error);
        });
    };

    const token = localStorage.getItem("token");
    getUser(token);
  }, [status]);

  useEffect(() => {
    const results = linkOriginal.filter((link) =>
      link.name.toLowerCase().includes(search.toLowerCase())
    );
    setLinks(results);
  }, [search]);

  const handleDelete = async () => {
    const token = localStorage.getItem("token");
    setIsDeleting(true);
    Api.delete("/items/Link/" + deletedLink.id, null, token)
      .then((response) => {
        //console.log(response);

        toast.success("Link berhasil dihapus");
        setIsDeleting(false);
        setLinks(links.filter((link) => link.id != deletedLink.id));
        setLinkOriginal(
          linkOriginal.filter((link) => link.id != deletedLink.id)
        );
        closeModal();
      })
      .catch((error) => {
        //console.log(error);
        toast.error("Link gagal dihapus");
        setIsDeleting(false);
      });
  };

  const handleApprove = async () => {
    const token = localStorage.getItem("token");
    setIsDeleting(true);
    Api.patch(
      "/items/Link/" + approvalLink.id,
      {
        status: "active",
      },
      token
    )
      .then((response) => {
        //console.log(response);

        if (response.errors) {
          toast.error("Link gagal diaktifkan");
          setIsDeleting(false);
          setIsOpenModalApprove(false);
          return;
        }

        toast.success("Link berhasil diaktifkan");
        setIsDeleting(false);
        setLinks(links.filter((link) => link.id != approvalLink.id));
        setLinkOriginal(
          linkOriginal.filter((link) => link.id != approvalLink.id)
        );

        setIsOpenModalApprove(false);
      })
      .catch((error) => {
        //console.log(error);
        toast.error("Link gagal diaktifkan");
        setIsDeleting(false);
      });
  };

  const handleEdit = async () => {
    const token = localStorage.getItem("token");
    setIsDeleting(true);
    Api.patch(
      "/items/Link/" + editLink.id,
      {
        name: editLink.name,
        reseller_name: editLink.reseller_name,
        wa_number: editLink.wa_number,
      },
      token
    )
      .then((response) => {
        //console.log(response);

        if (response.errors) {
          toast.error("Link gagal disimpan");
          setIsDeleting(false);
          setIsOpenModalEdit(false);
          return;
        }

        toast.success("Link berhasil diaktifkan");
        setIsDeleting(false);

        getInitialLinks(token, authUser.store_id.id);
        setIsOpenModalEdit(false);
      })
      .catch((error) => {
        //console.log(error);
        toast.error("Link gagal diaktifkan");
        setIsDeleting(false);
      });
  };

  return (
    <>
      <div className="flex flex-row w-full">
        <div className="lg:w-56 w-[3.35rem] ">
          <SideNav page="reseller" />
        </div>
        <div className="flex-1 justify-center items-center p-4 py-5">
          <div className="w-full">
            <div className="fixed top-14 justify-center items-center md:right-0 px-8 md:w-96 w-80 sm:top-5">
              <div className="px-2 py-2 shadow bg-white rounded-lg">
                <div className="flex flex-row gap-4 items-center">
                  <div className="flex w-full flex-row">
                    <input
                      type="text"
                      placeholder={
                        "Cari link reseller dari " + links.length + " data"
                      }
                      className="border-2 w-full border-gray-100 bg-gray-100 h-10 px-5 pr-16 rounded-lg text-sm focus:outline-none focus:bg-white"
                      onChange={(e) => {
                        setSearch(e.target.value);
                      }}
                    />
                    <button className="right-6 top-5 text-pink-500 -ml-8">
                      <FaSearch />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="px-4 pl-8 sm:pl-4 font-bold">Link Reseller</div>

            <div className="pt-24 md:pt-20 lg:pt-16">
              <div className="flex flex-row justify-center items-center gap-1 mb-4">
                <div className="w-1/2 flex flex-row gap-0.5 justify-center">
                  <button
                    className={
                      status == "active"
                        ? "bg-pink-600  flex flex-row items-center hover:bg-pink-700 hover:text-white text-white py-1 px-2 rounded text-xs md:text-sm"
                        : "bg-gray-200  flex flex-row items-center hover:bg-gray-700 hover:text-white text-gray-800 py-1 px-2 rounded text-xs md:text-sm"
                    }
                    onClick={() => {
                      setStatus("active");
                    }}>
                    Aktif
                  </button>
                  <button
                    className={
                      status == "pending"
                        ? "bg-pink-600  flex flex-row items-center hover:bg-pink-700 hover:text-white text-white py-1 px-2 rounded text-xs md:text-sm"
                        : "bg-gray-200  flex flex-row items-center hover:bg-gray-700 hover:text-white text-gray-800 py-1 px-2 rounded text-xs md:text-sm"
                    }
                    onClick={() => {
                      setStatus("pending");
                    }}>
                    Menunggu Persetujuan
                  </button>
                </div>
              </div>
              {isLoading ? (
                <div className="flex justify-center h-32 items-center">
                  <ReactLoading
                    type={"balls"}
                    color={"gray"}
                    height={48}
                    width={48}
                  />
                </div>
              ) : (
                <div className="container mx-auto">
                  <div className="flex-1 px-4 lg:px-12 flex flex-row  justify-center">
                    <div className="flex flex-col gap-2 w-full lg:w-3/4 ">
                      {links.map((item, index) => (
                        <div className="flex flex-col lg:flex-row text-sm bg-gray-50 gap-1 p-4">
                          <div className=" lg:w-1/4 font-semibold">
                            {item.name} <br />
                            <span className="font-normal text-xs">
                              {item.reseller_name}
                            </span>
                          </div>
                          <div className=" lg:w-1/2">
                            https://kataloqu.com/{item.slug}
                          </div>
                          <div className=" lg:w-1/4 flex flex-row gap-2 justify-end">
                            {status == "pending" ? (
                              <button
                                className="bg-teal-500 hover:bg-teal-700 text-white font-bold py-1 px-2 lg:py-2 lg:px-3 text-xs lg:text-sm rounded"
                                onClick={() => {
                                  setApprovalLink(item);
                                  setIsOpenModalApprove(true);
                                }}>
                                Terima
                              </button>
                            ) : (
                              <button
                                className="bg-purple-500 hover:bg-purple-700 text-white font-bold py-1 px-2 lg:py-2 lg:px-3 text-xs lg:text-sm rounded"
                                onClick={() => {
                                  setEditLink(item);
                                  setIsOpenModalEdit(true);
                                }}>
                                Edit
                              </button>
                            )}
                            <button
                              className="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2 lg:py-2 lg:px-3 text-xs lg:text-sm rounded"
                              onClick={() => {
                                setDeletedLink(item);
                                openModal();
                              }}>
                              Hapus
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {isOpen && (
              <div className="fixed inset-0 flex items-center justify-center z-30">
                <div className="fixed inset-0 bg-black opacity-50"></div>
                <div className="bg-white rounded-lg p-8 z-50 mx-4">
                  <p>Apakah anda yakin ingin menghapus link reseller ini?</p>
                  <p className="font-semibold">{deletedLink.name}</p>

                  <div className="flex gap-2 flex-row justify-between">
                    <button
                      onClick={closeModal}
                      className="mt-4 bg-gray-100 hover:bg-gray-200 text-gray-800 font-bold py-2 px-4 rounded">
                      Batal
                    </button>
                    {isDeleting ? (
                      <ReactLoading
                        type={"balls"}
                        color={"gray"}
                        height={10}
                        width={48}
                      />
                    ) : (
                      <button
                        onClick={() => {
                          handleDelete();
                        }}
                        className="mt-4 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
                        Ya, hapus
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
            {isOpenModalApprove && (
              <div className="fixed inset-0 flex items-center justify-center z-30">
                <div className="fixed inset-0 bg-black opacity-50"></div>
                <div className="bg-white rounded-lg p-8 z-50 mx-4">
                  <p>Terima persetujuan link reseller?</p>
                  <p className="font-semibold">{approvalLink.name}</p>

                  <div className="flex gap-2 flex-row justify-between">
                    <button
                      onClick={() => setIsOpenModalApprove(false)}
                      className="mt-4 bg-gray-100 hover:bg-gray-200 text-gray-800 font-bold py-2 px-4 rounded">
                      Batal
                    </button>
                    {isDeleting ? (
                      <ReactLoading
                        type={"balls"}
                        color={"gray"}
                        height={10}
                        width={48}
                      />
                    ) : (
                      <button
                        onClick={() => {
                          handleApprove();
                        }}
                        className="mt-4 bg-teal-500 hover:bg-teal-700 text-white font-bold py-2 px-4 rounded">
                        Ya, Terima
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}

            {isOpenModalEdit && (
              <div className="fixed inset-0 flex items-center justify-center z-30">
                <div className="fixed inset-0 bg-black opacity-50 "></div>
                <div className="bg-white rounded-lg p-8 z-50 mx-4 w-full lg:w-1/2">
                  <p className="font-semibold text-pink-600">
                    Edit Link Reseller
                  </p>
                  <p className="font-semibold mt-4">{editLink.name}</p>
                  <p className=" mb-4">
                    {" "}
                    https://kataloqu.com/
                    {editLink.slug}
                  </p>

                  <div className="my-1 flex flex-col gap-2">
                    <div className="flex flex-col md:flex-row gap-2">
                      <div className="my-1 w-full md:w-1/3 font-semibold">
                        <span className="text-sm">Nama toko</span>
                        <input
                          type="text"
                          className="border-2 border-gray-200 w-full rounded-lg px-3 py-2 mt-1 font-normal"
                          value={editLink.name}
                          onChange={(e) => {
                            setEditLink({ ...editLink, name: e.target.value });
                          }}
                        />
                      </div>
                      <div className="my-1 w-full md:w-1/3 font-semibold">
                        <span className="text-sm">Nama pemilik/reseller</span>
                        <input
                          type="text"
                          className="border-2 border-gray-200 w-full rounded-lg px-3 py-2 mt-1 font-normal"
                          value={editLink.reseller_name}
                          onChange={(e) => {
                            setEditLink({
                              ...editLink,
                              reseller_name: e.target.value,
                            });
                          }}
                        />
                      </div>
                      <div className="my-1 w-full md:w-1/3 font-semibold">
                        <span className="text-sm">Nomor whatsapp</span>
                        <input
                          type="text"
                          className="border-2 border-gray-200 w-full rounded-lg px-3 py-2 mt-1 font-normal"
                          value={editLink.wa_number}
                          onChange={(e) => {
                            setEditLink({
                              ...editLink,
                              wa_number: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex gap-2 flex-row justify-between">
                    <button
                      onClick={() => setIsOpenModalEdit(false)}
                      className="mt-4 bg-gray-100 hover:bg-gray-200 text-gray-800 font-bold py-2 px-4 rounded">
                      Batal
                    </button>
                    {isDeleting ? (
                      <ReactLoading
                        type={"balls"}
                        color={"gray"}
                        height={10}
                        width={48}
                      />
                    ) : (
                      <button
                        onClick={() => {
                          handleEdit();
                        }}
                        className="mt-4 bg-teal-500 hover:bg-teal-700 text-white font-bold py-2 px-4 rounded">
                        Simpan
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}

            <ToastContainer />
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminquLinkReseller;
